import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { MutationStatus, MutationUpdateTenantAccountSettingsArgs, UpdateTenantAccountSettingsInput } from '../gql-types.generated';
import { getStandardHeaders } from '../util/StandardRequestHeaders';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_UPDATE_TENANT_ACCOUNT_SETTINGS = gql`
  mutation updateTenantAccountSettings($input: UpdateTenantAccountSettingsInput!) {
    updateTenantAccountSettings(input: $input) {
      code
      message
      error
    }
  }
`;

export const mutationUpdateTenantAccountSettings = async (
  client: ApolloClient<NormalizedCacheObject>,
  tenantId: string,
  input: UpdateTenantAccountSettingsInput,
): Promise<MutationStatus | undefined> => {
  const baseHeaders = await getStandardHeaders(true);
  const headers = { ...baseHeaders, 'x-aptean-tenant': tenantId };
  const { data, errors } = await client.mutate<
    { updateTenantAccountSettings: MutationStatus },
    MutationUpdateTenantAccountSettingsArgs
  >({
    variables: { input },
    mutation: MUTATION_UPDATE_TENANT_ACCOUNT_SETTINGS,
    context: { headers },
  });

  if (errors && errors.length > 0) {
    errors.forEach(error => console.error(error));
    throw new Error('An error has occurred during the tenant settings update.');
  }

  return data?.updateTenantAccountSettings;
};
